import { render, staticRenderFns } from "./fun-edit-dialog.vue?vue&type=template&id=482c268b&"
import script from "./fun-edit-dialog.vue?vue&type=script&lang=ts&"
export * from "./fun-edit-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports